import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { GlobalThemeProvider } from '@zoom/react-ui'
import { selectZaConfig } from '../root/reducer'

const getInitialLightMode = () => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return true
  }

  const mediaQueryList = window.matchMedia('(prefers-color-scheme: light)')

  if (!mediaQueryList || !mediaQueryList.media) {
    return true
  }

  return mediaQueryList.matches || mediaQueryList.media === 'not all'
}

// Determine if OS is using lightMode
// Client Setting's styles will change according to the preference
const useLightModePreference = () => {
  const zaConfigOutput = useSelector(selectZaConfig)
  const [isLightMode, setIsLightMode] = useState(getInitialLightMode)
  const isAndroid = Boolean(
    zaConfigOutput?.product === 'mobile' &&
      zaConfigOutput?.userAgent?.includes('Android')
  )

  useEffect(() => {
    if (isAndroid) {
      setIsLightMode(false)
      GlobalThemeProvider.updateMode('dark')
    }
  }, [isAndroid])

  useEffect(() => {
    const handleOnThemeModeChange = (event) => {
      if (isAndroid) {
        setIsLightMode(false)
        GlobalThemeProvider.updateMode('dark')
        return
      }

      const theme = event.themeMode
      setIsLightMode(theme === 'light')
      GlobalThemeProvider.updateMode(theme === 'light' ? 'light' : 'dark')
    }

    if (zaConfigOutput && !isAndroid) {
      window.zoomSdk.addEventListener(
        'onThemeModeChange',
        handleOnThemeModeChange
      )
    }

    if (zaConfigOutput && !isAndroid) {
      return () => {
        window.zoomSdk.removeEventListener(
          'onThemeModeChange',
          handleOnThemeModeChange
        )
      }
    }
  }, [isAndroid, zaConfigOutput])

  return isLightMode
}

export default useLightModePreference
